(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.annoucement = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Bar heights change after load (fonts, countdown expiring, resizes);
      // keep the CSS vars in sync so the floating unit stays glued.
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        resizeObserver.observe(this);
        if (this.annoucement) resizeObserver.observe(this.annoucement);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // Measure the bar itself (<sticky-header>), not .section-header: the
      // section wrapper carries the floating-unit negative bottom margin and
      // some engines then report offsetHeight as |margin| instead of the
      // content height, which would feed back into the margin calc forever.
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      document.documentElement.style.setProperty('--annoucement-height', `${this.annoucement.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-past-content');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-past-content');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-past-content');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-early-access"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initEarlyAccessCountdown() {
      var sections = document.querySelectorAll('[data-countdown-date]');
      sections.forEach(function (section) {
        var dateStr = section.getAttribute('data-countdown-date');
        if (!dateStr) return;

        var targetDate = new Date(dateStr);
        if (isNaN(targetDate.getTime())) return;

        var els = {
          daysTens: section.querySelector('[data-ea-days-tens]'),
          daysOnes: section.querySelector('[data-ea-days-ones]'),
          hoursTens: section.querySelector('[data-ea-hours-tens]'),
          hoursOnes: section.querySelector('[data-ea-hours-ones]'),
          minsTens: section.querySelector('[data-ea-mins-tens]'),
          minsOnes: section.querySelector('[data-ea-mins-ones]'),
          secsTens: section.querySelector('[data-ea-secs-tens]'),
          secsOnes: section.querySelector('[data-ea-secs-ones]'),
        };

        function pad(n) {
          return n < 10 ? '0' + n : '' + n;
        }

        function update() {
          var now = new Date();
          var diff = targetDate - now;

          if (diff <= 0) {
            // Countdown finished — switch to ended state
            section.classList.add('early-access--ended');
            var endedEl = section.querySelector('[data-ea-ended]');
            if (endedEl) endedEl.style.display = '';
            clearInterval(timer);
            return;
          }

          var days = Math.floor(diff / (1000 * 60 * 60 * 24));
          var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((diff % (1000 * 60)) / 1000);

          var d = pad(days);
          var h = pad(hours);
          var m = pad(minutes);
          var s = pad(seconds);

          if (els.daysTens) els.daysTens.textContent = d[0];
          if (els.daysOnes) els.daysOnes.textContent = d[1];
          if (els.hoursTens) els.hoursTens.textContent = h[0];
          if (els.hoursOnes) els.hoursOnes.textContent = h[1];
          if (els.minsTens) els.minsTens.textContent = m[0];
          if (els.minsOnes) els.minsOnes.textContent = m[1];
          if (els.secsTens) els.secsTens.textContent = s[0];
          if (els.secsOnes) els.secsOnes.textContent = s[1];
        }

        update();
        var timer = setInterval(update, 1000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initEarlyAccessCountdown);
    } else {
      initEarlyAccessCountdown();
    }

    document.addEventListener('shopify:section:load', initEarlyAccessCountdown);
  })();

  } catch(e) { console.error(e); }
})();
})();
